import { render } from "./CommonFooter.vue?vue&type=template&id=6d0d8be0&scoped=true&ts=true"
import script from "./CommonFooter.vue?vue&type=script&lang=ts"
export * from "./CommonFooter.vue?vue&type=script&lang=ts"

import "./CommonFooter.vue?vue&type=style&index=0&id=6d0d8be0&lang=less&scoped=true"

import exportComponent from "D:\\code\\hyz-website\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6d0d8be0"]])

export default __exports__